// Valores dos enums Script1State / Script2State do backend (lado direito do enum).
// Mantidos manualmente em sincronia com:
//   backend: src/bot/script1/types.ts  e  src/bot/script2/types.ts

export const SCRIPT1_STATES: string[] = [
  'manutation',
  'other_user_propostal',
  'manutation_stop',
  'error_simulate',
  'warning_to_consult_later',
  'ask_for_want_form_link',
  'blid_shot',
  'ask_for_want_cancel_link',
  'processing_doc',
  'paid_stop_silence',
  'paid_stop',
  'support_to_auth_qi',
  'pending_propostal',
  'processing_propostal',
  'need_auth_pay_bank_triger',
  'need_auth_pay_bank',
  'ask_need_auth_pay_bank',
  'manual_analysis',
  'manual_analysis_stop',
  'propostal_expired',
  'ask_propostal_expired_renew',
  'pending_propostal_stop',
  'send_support',
  'checking_propostal',
  'v8_error',
  'v8_need_treatement',
  'paid',
  'get_in_touch',
  'ask_for_app_install',
  'need_instal_app',
  'ask_for_cpf',
  'confirm_cpf',
  'check_client_founds',
  'has_founds',
  'want_to_withdraw',
  'need_auth_banks',
  'wait_birth_date',
  'error',
  'dont_have_app',
  'ask_for_pix',
  'confirm_pix',
  'generate_propostal',
  'ask_for_banks_permission',
  'created_propostal',
  'no_founds',
  'stop',
  'auth_failed_stop',
  'need_go_to_fgts_caixa',
  'need_be_anniversary_membership',
  'human_support',
  'clt_not_is_elegible',
  'clt_is_elegible',
  'clt_data_prev_error',
  'clt_shot',
  'clt_shot_want_know',
  'clt_shot_preconsuting',
  'clt_consuting',
  'clt_shot_not_want',
  'need_update_pix',
  'need_update_pix_confirm',
  'pix_error',
  'askForFgts',
];

export const SCRIPT2_STATES: string[] = [
  'getInTouch',
  'askWantConsult',
  'unknownStateError',
  'preChekingMargin',
  'checkingMargin',
  'checkingMarginAgain',
  'chekingMarginErrorOutTime',
  'askForCpf',
  'confirmCpf',
  'consultError',
  'consultBlocked',
  'needUpdateDoc',
  'elegibilityErrorNoCpf',
  'elegibilityErrorDontFindConsult',
  'elegibilityError',
  'needHumanSupport',
  'scoreToLow',
  'unknownCanceledReason',
  'knownCanceledReason',
  'notPossibileNow',
  'marginLow',
  'hasMargin',
  'humanSupport',
  'needUpdateDocError',
  'askForPix',
  'hasPropostalShot',
  'confirmPix',
  'missInformationError',
  'scriptError',
  'generetingPropostal',
  'propostalGenereted',
  'notElegibile',
  'otherV8PartnerOperation',
  'propostalCreateError',
  'outAgeRange',
  'sendedFormalizationLink',
  'consultOutTime',
  'manualAnalysis',
  'processingPropostal',
  'paid',
  'paidWarningFinal',
  'hasMarginShot',
  'nameOrBirthDateError',
  'needUpDocToCreatePropostal',
  'manutation',
  'manutationStop',
  'consultWaiting',
  'createPropostalOutTime',
  'needMotherNameToCreateCltPropostal',
  'upMotherNameError',
  'pendingDoc',
  'cantFindMargin',
  'cltWithMarginShot',
  'wantToBlock',
  'checkingMarginWithCron',
  'propostalOzCancelation',
  'consultMarginError',
  'simulationError',
  'cltCheckIsClientName',
  'needNameAndBirthDate',
];
